import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=05d7bc89&"
import script from "./navbar.js?vue&type=script&lang=js&"
export * from "./navbar.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports